export const objectAnnotationModes = {
  annotation: 'annotation',
  verification: 'verification',
};
